module.exports = __webpack_public_path__ + "img/modal-header-close.a3f505e9.svg";